import createTsdApi from "../../../client-api/createTsdApi";
import {
  IdCardRegionContent,
  IdCardRegionContentCreateParams,
  IdCardRegionContentQueryParams,
  IdCardRegionContentUpdateParams,
} from "../../../entities/IdCardRegionContent/idCardRegionContent";
import tsdFetch, { TsdSearchParam } from "../fetch";

const idCardRegionContentApi = createTsdApi<
  IdCardRegionContent,
  IdCardRegionContentQueryParams,
  IdCardRegionContentCreateParams,
  IdCardRegionContentUpdateParams
>("id-card-region-contents", (params) => {
  const search: TsdSearchParam<IdCardRegionContentQueryParams>[] = [];

  ({
    ids: (() => {
      if (typeof params.ids !== "undefined") {
        params.ids.forEach((id) =>
          search.push({ key: "ids", value: String(id) })
        );
      }
    })(),
    limit: (() => {
      if (typeof params.limit !== "undefined") {
        search.push({
          key: "limit",
          value: String(params.limit),
        });
      }
    })(),
    offset: (() => {
      if (typeof params.offset !== "undefined") {
        search.push({
          key: "offset",
          value: String(params.offset),
        });
      }
    })(),
    idCardIds: (() => {
      if (typeof params.idCardIds !== "undefined") {
        params.idCardIds.forEach((id) =>
          search.push({ key: "idCardIds", value: String(id) })
        );
      }
    })(),
    idCardTemplateRegionIds: (() => {
      if (typeof params.idCardTemplateRegionIds !== "undefined") {
        params.idCardTemplateRegionIds.forEach((id) =>
          search.push({ key: "idCardTemplateRegionIds", value: String(id) })
        );
      }
    })(),
    uploadIds: (() => {
      if (typeof params.uploadIds !== "undefined") {
        params.uploadIds.forEach((id) =>
          search.push({ key: "uploadIds", value: String(id) })
        );
      }
    })(),
  }) satisfies {
    [key in keyof Required<IdCardRegionContentQueryParams>]: void | undefined;
  };

  return search;
});

const create = async (fields: IdCardRegionContentCreateParams) => {
  const formData = new FormData();

  formData.append("idCardId", String(fields.idCardId));
  formData.append(
    "idCardTemplateRegionId",
    String(fields.idCardTemplateRegionId)
  );

  if (typeof fields.textContent !== "undefined") {
    formData.append("textContent", fields.textContent);
  }

  if (typeof fields.optionsOverride !== "undefined") {
    formData.append("optionsOverride", JSON.stringify(fields.optionsOverride));
  }

  if (typeof fields.imageFile !== "undefined") {
    formData.append("imageFile", fields.imageFile);
  }

  const url = `/api/v1/id-card-region-contents`;
  return tsdFetch(url, {
    method: "POST",
    body: formData,
  });
};

export default {
  get: idCardRegionContentApi.get,
  getOne: idCardRegionContentApi.getOne,
  create,
};
